<template>
  <div id="app" class="wh">
    <router-view/>
    <!--<div :class="$i18n.locale == 'en-US' ? 'langClassCN':'langClassEN'" class="lang langClassCN pa cursor" @click="langClick"></div>-->
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {}
  },
  methods: {
    langClick () {
      if (this.$i18n.locale == 'en-US') {
        this.$i18n.locale = 'en-ZH'
      } else {
        this.$i18n.locale = 'en-US'
      }
    }
  },
  beforeCreate () {},
  created () {},
  mounted () {}
}
</script>

<style lang="scss">
@import "./assets/styles/common/functions";
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;*/
  font: 20px 'Microsoft YaHei';
  /*background-color: #000;*/
  height: 100%;
}
.lang{
  z-index: 1000;
  right: px2vw(32);
  bottom: px2vw(55);
  width: px2(100);
  height: px2(100);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.langClassCN{
  background-image: url("./assets/images/common/cn.png");
}
.langClassEN{
  background-image: url("./assets/images/common/en.png");
}
</style>



// WEBPACK FOOTER //
// src/App.vue